import { render, staticRenderFns } from "./Pos_sales_report_by_category.vue?vue&type=template&id=f8612006&"
import script from "./Pos_sales_report_by_category.vue?vue&type=script&lang=js&"
export * from "./Pos_sales_report_by_category.vue?vue&type=script&lang=js&"
import style0 from "./Pos_sales_report_by_category.vue?vue&type=style&index=0&id=f8612006&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports